import ActionButton from 'components/ActionButton';
import ChangeAddressModal from 'components/ChangeAddressModal';
import RenderInfo from 'components/RenderInfo';
import React, { useState } from 'react';
import { updateSalesChannel } from 'services/api/salesChannel';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const SalesChannelAddress = (props) => {
  const {
    details: {
      objectId = '',
      location = null,
      user: { objectId: userId = '' } = {},
    } = {},
    setLoading,
    fetchSalesChannelDetailsFn,
  } = props;
  const [changeAddressModalOpen, setChangeAddressModalOpen] = useState(false);

  const onChangeAddress = async (address) => {
    setLoading(true);
    try {
      await updateSalesChannel({
        id: objectId,
        addressId: address?.objectId,
      });
      await fetchSalesChannelDetailsFn();
      setChangeAddressModalOpen(false);
      showSuccess('Address updated successfully.');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['delivery-location-section']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Address</div>
        <ActionButton
          text={`${location ? 'Change' : 'Add'} Address`}
          active={true}
          isLoading={false}
          onClick={() => setChangeAddressModalOpen(true)}
        />
      </div>
      {location
        ? (
          <div className={styles['details-section']}>
            <div>
              <RenderInfo heading="Address ID" value={location.objectId} />
              <RenderInfo heading="Address" value={location.address} />
              <RenderInfo heading="Town" value={location.town} />
              <RenderInfo heading="Zip" value={location.zip} />
            </div>
            <div className={'mr-4'}>
              <RenderInfo heading="Contact Name" value={location.contactName} />
              <RenderInfo heading="Contact Phone" value={location.contactPhone} />
            </div>
          </div>
        ): (
          <div className={styles['empty-location-message']}>
              No Address Selected
          </div>
        )}
      {changeAddressModalOpen && (
        <ChangeAddressModal
          userId={userId}
          subscriptionId={'subscriptionId'}
          toggleModal={() => setChangeAddressModalOpen(!changeAddressModalOpen)}
          title="Change sales channel address"
          onAddressChange={onChangeAddress}
        />
      )}
    </div>
  );
};

export default SalesChannelAddress;
